import { render } from "./MyService.vue?vue&type=template&id=746413af&scoped=true"
import script from "./MyService.vue?vue&type=script&lang=js"
export * from "./MyService.vue?vue&type=script&lang=js"

import "./MyService.vue?vue&type=style&index=0&id=746413af&lang=less&scoped=true"

import exportComponent from "F:\\handzone_game\\10001-sdk\\web\\hzgamebox\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-746413af"]])

export default __exports__